// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ay-0";
export var optionCard = "_ay-1";